import type { IResponseApi } from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { IConfMaestra } from '@/modules/Configuracion/interfaces'
import type { AxiosResponse } from 'axios'
export class MaestraService extends BaseService<IConfMaestra> {
  constructor () {
    super({
      baseUrl: 'system/master/'
    })
  }
  async searchByTypeDependenci (
    tipo: string,
    dependencia: string
  ): Promise<AxiosResponse<IResponseApi<IConfMaestra[]>>> {
    return this.http.get<IResponseApi<IConfMaestra[]>>(
      `/list/${tipo}/${dependencia}`
    )
  }
  async searchByType (
    tipo: string
  ): Promise<AxiosResponse<IResponseApi<IConfMaestra[]>>> {
    return this.http.get<IResponseApi<IConfMaestra[]>>(`/list/${tipo}`)
  }
  async searchByCodName (
    params: Record<string, unknown>,
    tipo?: string
  ): Promise<AxiosResponse<IResponseApi<IConfMaestra[]>>> {
    return this.http.get<IResponseApi<IConfMaestra[]>>(
      tipo ? `/search-by-name-cod/${tipo}` : '/search-by-name-cod',
      { params }
    )
  }
}
